export default "__VITE_ASSET__DkAuWmpq__"